import React from "react";
import { useSelector } from 'react-redux';
import Slider from "react-slick";
import Card from "./card/Card";

const settings = {
  dots: false,
  infinite: true,
  easing: "ease-in-out",
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  centerPadding: "0",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const MostPopular = () => {
  const { items } = useSelector(state => state.mostPopularSearches);

  return (
    <div className="most-popular container">
      <div className="container">
        <div className="most-popular-head">
          <h3>Pencarian Terpopuler</h3>
          <p>Lihat Semua</p>
        </div>
        <Slider {...settings}>
          {items.map((product) => (
            <Card
              key={product.id}
              img={product.img}
              alt={product.alt}
              productName={product.productName}
              qty={product.qty}
              discount={product.discount}
              discountPrice={product.discountPrice}
              actualPrice={product.actualPrice}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default MostPopular;
